<template>
  <div class="app-header">
    <img
      v-if="back_button"
      @click="goBack"
      class="app-header__back-icon"
      src="../assets/_ionicons_svg_ios-arrow-back.svg"
    >
    <slot></slot>
    <img
      v-if="config_button"
      @click="showConfig"
      class="app-header__config-icon"
      src="../assets/_ionicons_svg_md-settings.svg"
    >
    <img
      v-if="close_button"
      @click="goBack"
      class="app-header__close-icon"
      src="../assets/_ionicons_svg_ios-close.svg"
    >
  </div>
</template>

<script>
export default {
  name: "AppHeader",
  props: {
    back_button: {
      type: Boolean
    },
    config_button: {
      type: Boolean
    },
    close_button: {
      type: Boolean
    }
  },
  methods: {
    goBack: function() {
      this.$router.back();
    },
    showConfig: function() {
      this.$router.push({ name: "config", params: { showBackButton: true } });
    }
  }
};
</script>